import { Dispatch, SetStateAction } from "react";
import { FileWithPath } from "react-dropzone";
import { HStack } from "@chakra-ui/react";
import { FormFieldLabel } from "../../components/formFieldLabel/FormFieldLabel";
import { FileUpload } from "../../components/fileUpload/FileUpload";

export type UploadFileType = {
  keywordsExc: FileWithPath[];
  keywordsInc: FileWithPath[];
};

interface KeywordsFileProps {
  keywordsIncFile: UploadFileType;
  setKeywordsIncFile: Dispatch<SetStateAction<UploadFileType>>;
}

export const KeywordsUploadBox = ({
  setKeywordsIncFile,
}: KeywordsFileProps) => {
  const acceptedFileTypes = "text/plain, application/gzip";

  const setIncFiles = (name: string, files: FileWithPath[]) => {
    setKeywordsIncFile((prevFiles) => ({ ...prevFiles, [name]: files }));
  };

  return (
    <>
      <HStack>
        <FormFieldLabel
          mt={0}
          label={"Keyword list"}
          // subLabel={"Import only .txt"}
          isRequired={true}
          // toolTip={"Each line in the .txt file will be considered a keyword."}
        >
          <FileUpload
            name={"keywordsInc"}
            acceptedFileTypes={acceptedFileTypes}
            maxFiles={1}
            setFiles={setIncFiles}
          />
        </FormFieldLabel>
      </HStack>
    </>
  );
};